module.exports = __webpack_public_path__ + "img/sch2-title.22c85882.png";